usersModule.controller('UsersHierarchyController',
    ['$scope', 'User', 'SearchFilters', 'usersHierarchyService', 'dealershipService', 'imSessionVarsService', 'usersMgEvents',
        'TLCError','AppErrorCodes','growl',
    function ($scope, User, SearchFilters, usersHierarchyService, dealershipService, imSessionVarsService, usersMgEvents,
        TLCError,AppErrorCodes, growl) {
        $scope.divisions = [{'Id': 0, 'DisplayName': 'Select'}];
        $scope.regions = [];
        $scope.districts = [];
        $scope.groups = [];
        $scope.dealerships = [];
        $scope.totalDivisions = 0;
        $scope.totalRegions = 0;
        $scope.totalDistricts = 0;
        $scope.totalGroups = 0;
        $scope.totalDealerships = 0;
        $scope.selectedLeafs = [];
        $scope.selectedUser = new User();
        $scope.divisionEnabled = false;

        $scope.pageNumber = 0;

        // filters
        $scope.filters = new SearchFilters();

        init();

        function init() {
            $scope.providerId = imSessionVarsService.getCurrentProviderId();
            // We need to remove the next 3 lines, this is only for testing
            //$scope.selectedUser.id = '545271e085e0a805bcd4357e';
            getProviderDivisions();
            $scope.divisionEnabled = false;
            //getHierarchy();
        }

        function getProviderDivisions(){
            usersHierarchyService.getProviderDivisions($scope.providerId).success(function (response) {
                if (response.length > 0) {
                    $scope.divisions = $scope.divisions.concat(response);
                    $scope.totalDivisions = response.length;
                    $scope.selectedDivision = $scope.divisions[0].Id;
                    $scope.changeDivision();
                    if ($scope.totalDivisions == 1) {
                        $scope.selectedDivision = $scope.divisions[1].Id;
                        $scope.changeDivision();
                    }
                }
                else
                {
                    $scope.selectedDivision = $scope.divisions[0].Id;
                    throw new TLCError(new Error('Provider Hierarchy is not setup'),AppErrorCodes.UserHierarchyController_GeneralError);
                }
            }).error(function (response, status, headers, config) {
                throw new TLCError(new Error(response),AppErrorCodes.UserHierarchyController_GeneralError);
            });
        }

        $scope.$on(usersMgEvents.userSelected, function(event, user) {
            $scope.selectedUser = angular.copy(user);
            $scope.divisionEnabled = true;
            getHierarchy();
        });

        $scope.$on(usersMgEvents.userCleared, function(event) {
            $scope.selectedUser = new User();
            $scope.selectedDivision = $scope.divisions[0].Id;
            $scope.changeDivision();
            $scope.divisionEnabled = false;
        });

        $scope.$on(usersMgEvents.userCreated, function(event, user) {
            $scope.selectedUser = angular.copy(user);
            $scope.divisionEnabled = true;
        });

        $scope.changeDivision = function() {
            $scope.regions = [];
            $scope.districts = [];
            $scope.groups = [];
            $scope.dealerships = [];
            $scope.regions = [{'Id': 0, 'DisplayName': 'Select'}];
            $scope.selectedRegion = null;
            $scope.selectedDistrict = null;
            $scope.selectedGroup = null;
            $scope.selectedDealership = null;
            if ($scope.selectedDivision != 0)
               getRegionsByDivision();
        };

        $scope.changeRegion = function() {
            $scope.districts = [];
            $scope.groups = [];
            $scope.dealerships = [];
            $scope.districts = [{'Id': 0, 'DisplayName': 'Select'}];
            $scope.selectedDistrict = null;
            $scope.selectedGroup = null;
            $scope.selectedDealership = null;
            if ($scope.selectedRegion != 0)
                getDistrictsByRegion();
        };

        $scope.changeDistrict = function() {
            $scope.groups = [];
            $scope.dealerships = [];
            $scope.groups = [{'Id': 0, 'DisplayName': 'Select'}];
            $scope.selectedGroup = null;
            $scope.selectedDealership = null;
            if ($scope.selectedDistrict != 0)
                getGroupsByDistrict();
        };

        $scope.changeGroup = function() {
            $scope.dealerships = [];
            $scope.dealerships = [{'Id': 0, 'LegalName': 'Select'}];
            $scope.selectedDealership = null;
            if ($scope.selectedGroup != 0)
                getDealershipsByGroup();
        };

        $scope.onSelectLeaf = function(leaf, leafLevel){
            $scope.selectedLeaftoRemove = leaf;
            $scope.leafLevel = leafLevel;
        };

        $scope.searchWithFilters = function(){
            $scope.dealerships = [];
            $scope.dealerships = [{'Id': 0, 'LegalName': 'Select'}];
            refresh();
        };

        $scope.assignUsertoHierarchyLeaf = function(){
            $scope.selectedLeaf = '';
            var leafLevel = '';
            if ($scope.selectedDealership && $scope.selectDealership != 0) {
                $scope.selectedLeaf = $scope.selectedDealership;
                postUsertoDealership('DEALERSHIP');
            }
            else {
                if ($scope.selectedGroup && $scope.selectedGroup != 0) {
                    $scope.selectedLeaf = $scope.selectedGroup;
                    leafLevel = 'GROUP';
                }
                else
                    if ($scope.selectedDistrict && $scope.selectedDistrict != 0) {
                        $scope.selectedLeaf = $scope.selectedDistrict;
                        leafLevel = 'DISTRICT';
                    }
                    else
                        if ($scope.selectedRegion && $scope.selectedRegion != 0) {
                            $scope.selectedLeaf = $scope.selectedRegion;
                            leafLevel = 'REGION';
                        }
                        else
                            if ($scope.selectedDivision && $scope.selectedDivision != 0) {
                                $scope.selectedLeaf = $scope.selectedDivision;
                                leafLevel = 'DIVISION';
                            }
                if ($scope.selectedLeaf && $scope.selectedLeaf != '')
                        postUsertoHierarchyLeaf(leafLevel);
            }
        };

        $scope.removeUserfromHierarchyLeaf = function(){
            if (typeof  $scope.selectedLeaftoRemove != 'undefined')
                deleteUserfromHierarchyLeaf();
            else
                growl.warning('There is no hierarchy selected');
        };

        function getRegionsByDivision(){
            usersHierarchyService.getRegionsByDivision($scope.providerId, $scope.selectedDivision).success(function (response) {
                if (response.length > 0) {
                    $scope.regions = $scope.regions.concat(response);
                    $scope.totalRegions = response.length;
                    $scope.selectedRegion = $scope.regions[0].Id;
                    if ($scope.totalRegions == 1) {
                        $scope.selectedRegion = $scope.regions[1].Id;
                        $scope.changeRegion();
                    }
                }
            }).error(function (response, status, headers, config) {
                throw new TLCError(new Error(response),AppErrorCodes.UserHierarchyController_GeneralError);
            });
        }

        function getDistrictsByRegion(){
            usersHierarchyService.getDistrictsByRegion($scope.providerId, $scope.selectedRegion).success(function (response) {
                if (response.length > 0) {
                    $scope.districts = $scope.districts.concat(response);
                    $scope.totalDistricts = response.length;
                    $scope.selectedDistrict = $scope.districts[0].Id;
                    if ($scope.totalDistricts == 1) {
                        $scope.selectedDistrict = $scope.districts[1].Id;
                        $scope.changeDistrict();
                    }
                }
            }).error(function (response, status, headers, config) {
                throw new TLCError(new Error(response),AppErrorCodes.UserHierarchyController_GeneralError);
            });
        }

        function getGroupsByDistrict(){
            usersHierarchyService.getGroupsByDistrict($scope.providerId, $scope.selectedDistrict).success(function (response) {
                if (response.length > 0) {
                    $scope.groups = $scope.groups.concat(response);
                    $scope.totalGroups = response.length;
                    $scope.selectedGroup = $scope.groups[0].Id;
                    if ($scope.totalGroups == 1) {
                        $scope.selectedGroup = $scope.groups[1].Id;
                        $scope.changeGroup();
                    }
                }
            }).error(function (response, status, headers, config) {
                throw new TLCError(new Error(response),AppErrorCodes.UserHierarchyController_GeneralError);
            });
        }

        function getDealershipsByGroup(){
            usersHierarchyService.getDealershipsByGroup($scope.providerId, $scope.selectedGroup).success(function (response) {
                if (response.length > 0) {
                    $scope.dealerships = $scope.dealerships.concat(response);
                    $scope.totalDealerships = response.length;
                    $scope.selectedDealership = $scope.dealerships[0].Id;
                    if ($scope.totalDealerships == 1) {
                        $scope.selectedDealership = $scope.dealerships[1].Id;
                    }
                }
            }).error(function (response, status, headers, config) {
                throw new TLCError(new Error(response),AppErrorCodes.UserHierarchyController_GeneralError);
            });
        }

        function refresh() {
            //show the dealerships
            dealershipService.searchDealerships($scope.pageNumber, null, null, null, $scope.filters)
                .then(function (response) {
                    if (response.TotalItemCount > 0) {
                        $scope.dealerships = $scope.dealerships.concat(response.ItemList);
                        _.each($scope.dealerships, function(dealership){
                            if (dealership.LegalName != 'Select') {
                                dealership.Id = dealership.id;
                                dealership.LegalName = dealership.name;
                            }
                        });
                        $scope.totalDealerships = response.TotalItemCount;
                        $scope.selectedDealership = $scope.dealerships[0].Id;
                        if ($scope.totalDealerships == 1) {
                            $scope.selectedDealership = $scope.dealerships[1].Id;
                        }
                    }
                    else {
                        growl.warning('Dealerships not found.');
                    }
                }, function (response) { // rejected
                    throw new TLCError(new Error(response),AppErrorCodes.UserHierarchyController_GeneralError);
                }, function (response) { // notify
                    throw new TLCError(new Error(response),AppErrorCodes.UserHierarchyController_GeneralError);
                }).finally(function () {
                    $scope.busy = false;
                });
        }

        function getHierarchy(){
            usersHierarchyService.getHierarchy($scope.selectedUser.id).success(function(response){
                if (response.length > 0){
                    $scope.selectedUser.divisions = $scope.selectedUser.divisions.concat(response.filter(function (value) {
                        return value.LevelCode == 'DIVISION';}));
                    _.each($scope.selectedUser.divisions, function(division) { division.selected = false; });
                    $scope.selectedUser.regions = $scope.selectedUser.regions.concat(response.filter(function (value) {
                        return value.LevelCode == 'REGION';}));
                    _.each($scope.selectedUser.regions, function(region) { region.selected = false; });
                    $scope.selectedUser.districts = $scope.selectedUser.districts.concat(response.filter(function (value) {
                        return value.LevelCode == 'DISTRICT';}));
                    _.each($scope.selectedUser.districts, function(district) { district.selected = false; });
                    $scope.selectedUser.groups = $scope.selectedUser.groups.concat(response.filter(function (value) {
                        return value.LevelCode == 'GROUP';}));
                    _.each($scope.selectedUser.groups, function(group) { group.selected = false; });
                };
                usersHierarchyService.getHierarchyDealerships($scope.providerId, $scope.selectedUser.id).success(function(response){
                  if (response.length > 0){
                      $scope.selectedUser.dealerships = $scope.selectedUser.dealerships.concat(response);
                      _.each($scope.selectedUser.dealerships, function(dealership){dealership.selected = false;});
                  }
                })
                .error(function(response, status, headers, config){
                    throw new TLCError(new Error('There was an error retrieving the Hierarchy Dealerships for this user'),AppErrorCodes.UserHierarchyController_GeneralError);
                });
            })
            .error(function(response, status, headers, config){
                throw new TLCError(new Error('There was an error retrieving the Hierarchy for this user'),AppErrorCodes.UserHierarchyController_GeneralError);
            });
        }


        function postUsertoHierarchyLeaf(leafLevel){
            usersHierarchyService.postUsertoHierarchyLeaf($scope.providerId, $scope.selectedLeaf, $scope.selectedUser.id).success(function(response){
                switch(leafLevel) {
                    case 'DIVISION':
                            $scope.selectedUser.divisions = $scope.selectedUser.divisions.concat(findLeaf($scope.divisions, $scope.selectedLeaf));
                        break;
                    case 'REGION':
                        $scope.selectedUser.regions = $scope.selectedUser.regions.concat(findLeaf($scope.regions, $scope.selectedLeaf));
                        break;
                    case 'DISTRICT':
                        $scope.selectedUser.districts = $scope.selectedUser.districts.concat(findLeaf($scope.districts, $scope.selectedLeaf));
                        break;
                    case 'GROUP':
                        $scope.selectedUser.groups = $scope.selectedUser.groups.concat(findLeaf($scope.groups, $scope.selectedLeaf));
                        break;
                };
                })
                .error(function (response, status, headers, config){
                    throw new TLCError(new Error('There was an error associating the hierarchy to this user, Please try again!'),AppErrorCodes.UserHierarchyController_UserAssocError);
                });
        }

        function deleteUserfromHierarchyLeaf(){
            if ($scope.leafLevel != 'DEALERSHIP') {
                usersHierarchyService.deleteUserfromHierarchyLeaf($scope.providerId, $scope.selectedLeaftoRemove, $scope.selectedUser.id).success(function (response) {
                    switch ($scope.leafLevel) {
                        case 'DIVISION':
                            $scope.selectedUser.divisions.splice(($scope.selectedUser.divisions.indexOf(findLeaf($scope.selectedUser.divisions, $scope.selectedLeaftoRemove))), 1);
                            break;
                        case 'REGION':
                            $scope.selectedUser.regions.splice(($scope.selectedUser.regions.indexOf(findLeaf($scope.selectedUser.regions, $scope.selectedLeaftoRemove))), 1);
                            break;
                        case 'DISTRICT':
                            $scope.selectedUser.districts.splice(($scope.selectedUser.districts.indexOf(findLeaf($scope.selectedUser.districts, $scope.selectedLeaftoRemove))), 1);
                            break;
                        case 'GROUP':
                            $scope.selectedUser.groups.splice(($scope.selectedUser.groups.indexOf(findLeaf($scope.selectedUser.groups, $scope.selectedLeaftoRemove))), 1);
                            break;
                    }
                    ;
                })
                .error(function (response, status, headers, config) {
                    throw new TLCError(new Error('There was an error associating the hierarchy to this user, Please try again!'),AppErrorCodes.UserHierarchyController_UserAssocError);
                });
            }
            else{
                usersHierarchyService.deleteUserfromDealership($scope.selectedLeaftoRemove, $scope.selectedUser.id).success(function(response){
                    $scope.selectedUser.dealerships.splice(($scope.selectedUser.dealerships.indexOf(findLeaf($scope.selectedUser.dealerships, $scope.selectedLeaftoRemove))), 1);
                })
                .error(function (response, status, headers, config){
                    throw new TLCError(new Error('There was an error associating the dealership to this user, Please try again!'),AppErrorCodes.UserHierarchyController_UserAssocError);
                });
            }
        }

        function findLeaf(leafs, leafToFind){
            var foundStatus = _.find(leafs, function(leaf) {
                var id = leaf.Id;
                return id === leafToFind;
            });
            return foundStatus ? foundStatus : 0;
        }

        function postUsertoDealership(){
            usersHierarchyService.postUsertoDealership($scope.selectedDealership, $scope.selectedUser.id)
            .success(function(response){
                $scope.selectedUser.dealerships = $scope.selectedUser.dealerships.concat(findLeaf($scope.dealerships, $scope.selectedLeaf));
            })
            .error(function (response, status, headers, config){
                throw new TLCError(new Error('There was an error associating the dealership to this user, Please try again!'),AppErrorCodes.UserHierarchyController_UserAssocError);
            });
        }
    }
]);